import { API_BASE_URL } from '../config';
import createHttpClient from './HttpClient';

function createSubscriptionService(baseURL: string) {
  const httpClient = createHttpClient(baseURL);

  return {
    createCheckoutSession: async ({
      isSandbox = false,
      billingPeriod,
      subscriptionType,
    }: {
      isSandbox: boolean;
      billingPeriod: 'monthly' | 'yearly';
      subscriptionType: 'regular' | 'professional';
    }): Promise<{ url: string }> => {
      return httpClient.post('/create-checkout-session', {
        isSandbox,
        billingPeriod,
        subscriptionType,
      });
    },
    getUserSubscriptions: async (userId: number) => {
      return httpClient.get(`/subscriptions/users/${userId}`);
    },
  };
}

export const subscriptionService = createSubscriptionService(API_BASE_URL!);
